query getLightCampaignMaterials {
  getLightCampaignMaterials {
    name
    materials {
      displayName
      hasFile
      files {
        file {
          cdnUrl
        }
        previewFile {
          cdnUrl
        }
      }
    }
  }
}
